import './template.scss';

import type { TemplateProps } from 'keycloakify/login/TemplateProps';
import { ReactNode, useEffect, useMemo, useState } from 'react';

import bgOne from './assets/bg-one.svg';
import bgThree from './assets/bg-three.svg';
import bgTwo from './assets/bg-two.svg';
import cat from './assets/cat.svg';
import { ReactComponent as Close } from './assets/close-icon.svg';
import Footer from './components/Footer/Footer';
import Navbar from './components/Navbar/Navbar';
import type { KcContext } from './kcContext';

const bgImages = [bgOne, bgTwo, bgThree];

// We use a custom template with {children} instead of {formNode} so we could use this template for any page.
export type GgzeTemplateProps = Omit<TemplateProps<KcContext, any>, 'formNode'> & {
  doUseDefaultCss?: boolean;
  children?: ReactNode;
  showBackgroundImage?: boolean;
  showPrivacyPolicy?: boolean;
};

export const kcProps = {
  kcButtonClass: 'btn',
  kcButtonPrimaryClass: 'btn btn-primary',
  kcButtonBlockClass: 'btn-block',
  kcButtonLargeClass: 'btn-large',
  kcFormGroupClass: 'kc-form-group',
  kcLabelClass: 'kc-label',
  kcInputClass: 'kc-input',
  kcContentWrapperClass: 'kc-content-wrapper row',
  kcFormSocialAccountContentClass: 'kc-form-social-account-content',
  kcFormSocialAccountClass: 'kc-form-social-account col-xs-12 col-sm-6',
};

export default function Template(props: GgzeTemplateProps) {
  // Get random image from array and memoize it.
  const randomBgImage = useMemo(() => bgImages[Math.floor(Math.random() * bgImages.length)], []);

  const { kcContext, children, showBackgroundImage = true, showPrivacyPolicy = true } = props;

  const { message, isAppInitiatedAction } = kcContext;

  const [isMessageDismissed, setIsMessageDismissed] = useState(false);

  //useEffect hook to reset dimissed message
  useEffect(() => {
    setIsMessageDismissed(false);
  }, [message]);

  return (
    <div className="template">
      {process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'acc' ? (
        <div className="banner banner-test-environment">JE BEVINDT JE OP DE TESTOMGEVING</div>
      ) : null}
      <Navbar />
      <main>
        <div id="kc-content">
          <div id="kc-content-wrapper">
            <div className="cat">
              <img src={cat} alt="Illustratie van een kat" />
            </div>
            {/* App-initiated actions should not see warning messages about the need to complete the action during login. */}
            {!isMessageDismissed &&
              message !== undefined &&
              message.summary != 'false' &&
              (message.type !== 'warning' || !isAppInitiatedAction) && (
                <div className={`alert alert-${message.type}`}>
                  {message.type === 'success' && <span className=""></span>}
                  {message.type === 'warning' && <span className=""></span>}
                  {message.type === 'error' && <span className=""></span>}
                  {message.type === 'info' && <span className=""></span>}
                  <span
                    className="kc-feedback-text"
                    dangerouslySetInnerHTML={{
                      __html: message.summary,
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => setIsMessageDismissed(true)}
                    className="alert-dismiss"
                  >
                    <Close />
                  </button>
                </div>
              )}

            {children}
          </div>
        </div>
        {showPrivacyPolicy ? (
          <div className="privacy-text">
            Maak je gebruik van een leeromgeving van je werkgever of school, dan zijn zij
            verantwoordelijk voor de verwerking van jouw persoonsgegevens in die leeromgeving. Voor
            het overige blijft GGZ Ecademy verantwoordelijk (zoals jouw account). Meer weten? Lees
            onze{' '}
            <a href="https://ggzecademy.nl/privacy/" target="_blank" rel="noreferrer">
              Privacyverklaring
            </a>
            .
          </div>
        ) : null}
        {showBackgroundImage ? (
          <img src={randomBgImage} alt="achtergrondafbeelding" className="bg-image" />
        ) : null}
      </main>
      <Footer />
    </div>
  );
}
